export default __webpack_public_path__ + "static/media/math-magicians3.6569f1fa.png";